// Estado da navegação que sobrevive à navegação: o último separador visitado em
// cada módulo e o interruptor "Ver como comissão". Guardado no localStorage —
// se não houver storage (modo privado), vale só para a sessão.
import { useSyncExternalStore } from 'react'

const safeGet = (key: string) => {
  try { return localStorage.getItem(key) } catch { return null }
}
const safeSet = (key: string, value: string) => {
  try { localStorage.setItem(key, value) } catch { /* sem storage: fica só em memória */ }
}

// ── Último separador por módulo ────────────────────────────────────────────────
const lastKey = (condominioId: string, moduleId: string) => `nav:last:${condominioId}:${moduleId}`

/** Caminho relativo (ex.: 'finance/payments') da última página visitada no módulo. */
export function getLastVisited(condominioId: string, moduleId: string): string | null {
  return safeGet(lastKey(condominioId, moduleId))
}

export function setLastVisited(condominioId: string, moduleId: string, path: string) {
  safeSet(lastKey(condominioId, moduleId), path)
}

// ── "Ver como comissão" ─────────────────────────────────────────────────────────
const COMMITTEE_VIEW_KEY = 'nav:committeeView'
let committeeView = safeGet(COMMITTEE_VIEW_KEY) === 'true'
const listeners = new Set<() => void>()

export function setCommitteeView(next: boolean) {
  committeeView = next
  safeSet(COMMITTEE_VIEW_KEY, String(next))
  listeners.forEach((l) => l())
}

export function useCommitteeView(): boolean {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l) } },
    () => committeeView,
  )
}
